// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css'; // Correct path
import App from './App';
import { AuthProvider } from './context/AuthContext'; // Correct path
import reportWebVitals from './reportWebVitals';
// Remove this import as we don't need to preload the model anymore
// import glossaryOptimizerService from './services/glossary/glossaryOptimizerService';

// Remove the preloading block
/*
console.log('Initiating frontend glossary optimization model preload...');
glossaryOptimizerService.preloadModel(progress => {
  // Optional: You can log progress here if needed
  if (progress.status === 'progress') {
    // console.debug(`Model loading: ${progress.file} - ${Math.round(progress.progress * 100)}%`);
  } else if (progress.status === 'ready' || progress.status === 'done') {
    // console.info(`Model loading status: ${progress.status}`);
  }
}).catch(error => {
  console.error("Failed to preload glossary optimization model on startup:", error);
});
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();